import { mutatorAction } from "satcheljs";

import { TeamMemberPermissionsStore } from "../store/TeamMemberPermissionsStore";

/**
 * Reset the team member permissions for the current team to given value.
 */
export const resetTeamMemberPermissions = mutatorAction("resetTeamMemberPermissions", () => {
    TeamMemberPermissionsStore().permissions = null;
});